import {useCallback, useEffect} from "react";
import {batch, useComputed, useSignal} from "@preact/signals-react";
import {postSubmit, isEmpty} from "@ui-seeker/utils";

import {DATE_METRICS, WEBBACK_V2_API } from "@constants";
import {useToast} from "@hooks";
import {isLoadingCommonFilters, commonFiltersValue, submittedFilters, splitKpi, isSystemBusy} from "@signals";
import {TABS_TABLE} from "../@contants";
import {PriceEvolutionCurrentTabId, PriceEvolutionCurrentTabLabel, PriceEvolutionTabsTableID} from "../@signals";


export default function usePriceEvolutionTableMinMax() {
	const { showToast } = useToast()
	const data = useSignal({})
	const localLoading = useSignal(false)
	const localMetric = useSignal(DATE_METRICS.MONTHLY)
	const isPercentage = useSignal(false)
	const isSplitBySku = useSignal(true)

	const isLoading = useComputed(() => isLoadingCommonFilters.value || localLoading.value)
	const currentData = useComputed(() => {
		return PriceEvolutionTabsTableID.value !== TABS_TABLE.MIN_MAX ? [] : data.value[PriceEvolutionCurrentTabId.value] || []
	})
	const selectedLabel = useComputed(() => {
		return PriceEvolutionTabsTableID.value !== TABS_TABLE.MIN_MAX ? null : PriceEvolutionCurrentTabLabel.value
	})

	useEffect(() => {
		if (isLoading.value && isLoadingCommonFilters.value) {
			data.value = {}
			handleSubmit()
		}
	}, [isLoading.value]);


	useEffect(() => {
		if (PriceEvolutionCurrentTabId.value && !isLoading.value && !(PriceEvolutionCurrentTabId.value in data.value))
			handleSubmit(true)
	}, [PriceEvolutionCurrentTabId.value]);

	const handleSubmit = (useTab=false, changeMetric=false) => {
		const filters = {...commonFiltersValue.value}
		if (useTab) {
			if (isSplitBySku.value) {
				filters.sku = [PriceEvolutionCurrentTabId.value]
			} else {
				filters.retailer = [PriceEvolutionCurrentTabId.value]
			}
		}

		if (!localLoading.value)
			localLoading.value = true
		if  (PriceEvolutionTabsTableID.value !== null)
		if (!changeMetric)
			PriceEvolutionTabsTableID.value = null
		postSubmit(`${WEBBACK_V2_API}/pricing/price-evolution/table-min-max`, {
			...filters,
			metric: localMetric.value
		}).then(res => batch(() => {
			localLoading.value = false
			data.value = {...data.value, ...res.tableMinMax}
			isPercentage.value = res.isPercentage
			isSplitBySku.value = res.isSplitBySku
			if(!PriceEvolutionTabsTableID.value && !isEmpty(res.tableMinMax))
				PriceEvolutionTabsTableID.value = TABS_TABLE.MIN_MAX
		})).catch(() => batch(() => {
			isSystemBusy.value = true
			localLoading.value = false
		}))
	}

	const handleChangeMetric = useCallback(newValue => batch(() => {
		localLoading.value = true
		localMetric.value = newValue
		data.value = {}
		handleSubmit(true, true)
	}), [])

	const handleExcel = useCallback(() => showToast.promiseExcel(
		`${WEBBACK_V2_API}/pricing/price-evolution/table-min-max/excel/${PriceEvolutionCurrentTabId.value}`, {
			...commonFiltersValue.value,
			metric: localMetric.value,
			splitKpi: Array.isArray(splitKpi.value) ? splitKpi.value[0] : splitKpi.value
		}, null, {
			onError: data => {
				if (data.toString().includes('Error')) return 'Excel file size exceeded'
			}
		}), [localMetric.value, JSON.stringify(submittedFilters.value)])

	return {
		isLoading: isLoading.value,
		allData: data.value,
		isPercentage: isPercentage.value,
		isSplitBySku: isSplitBySku.value,
		currentData: currentData.value,
		tableMetric: localMetric.value,
		selectedLabel: selectedLabel.value,

		handleChangeMetric,
		handleExcel
	}
}